import { render, staticRenderFns } from "./detailed.vue?vue&type=template&id=a56daabc"
import script from "./detailed.vue?vue&type=script&lang=js"
export * from "./detailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports